import React from 'react';
import classes from './block3.module.css';
import img1 from './images/img.png';
import img2 from './images/img_1.png';
import img3 from './images/img_2.png';
import { API_BASE_URL } from '../../../config/api';

const Block3 = () => {
    const fallbackSlides = React.useMemo(
        () => [
            {
                id: "fallback-promo-1",
                left_image: img1,
                date_text: "с 23.10.2025 по 31.03.2026",
                title: "Консультация бесплатно",
                body: "Подбор стрижки\nРекомендации по уходу\nИсправление неудачных стрижек\nСоздание программы для достижения желаемого эффекта!",
            },
        ],
        []
    );
    const [slides, setSlides] = React.useState(fallbackSlides);
    const [activeIndex, setActiveIndex] = React.useState(0);

    React.useEffect(() => {
        fetch(`${API_BASE_URL}/api/promotions/`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to load promotions");
                }
                return response.json();
            })
            .then((data) => {
                if (!Array.isArray(data) || data.length === 0) return;
                const normalized = data.map((item, index) => ({
                    ...item,
                    id: item.id || `promo-${index}`,
                    left_image: item.left_image && !item.left_image.startsWith("http")
                        ? `${API_BASE_URL}${item.left_image}`
                        : item.left_image,
                }));
                setSlides(normalized);
                setActiveIndex(0);
            })
            .catch(() => {
                setSlides(fallbackSlides);
            });
    }, [fallbackSlides]);

    React.useEffect(() => {
        if (slides.length <= 1) return undefined;
        const intervalId = window.setInterval(() => {
            setActiveIndex((prev) => (prev + 1) % slides.length);
        }, 7000);
        return () => window.clearInterval(intervalId);
    }, [slides.length]);

    const currentSlide = slides[activeIndex] || fallbackSlides[0];

    const goToSlide = (index) => {
        setActiveIndex(index);
    };

    return (
        <div className={classes._}>
            <img src={currentSlide.left_image} alt={currentSlide.title} className={classes.img1} />
            <img src={img2} alt={''} className={classes.img2} />
            <img src={img3} alt={''} className={classes.img3} />
            <div className={classes.block}>
                <div className={classes.text1}>{currentSlide.date_text}</div>
                <div className={classes.text2}>{currentSlide.title}</div>
                <div className={classes.text3}>{currentSlide.body}</div>
                {slides.length > 1 && (
                    <div className={classes.sliderDots}>
                        {slides.map((slide, index) => (
                            <button
                                key={slide.id}
                                type="button"
                                className={index === activeIndex ? `${classes.dot} ${classes.dotActive}` : classes.dot}
                                onClick={() => goToSlide(index)}
                                aria-label={`Показать акцию ${index + 1}`}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Block3;